import { h } from "preact";
import { useState, useEffect } from "preact/hooks";

import { Box, Button, Card, CardMedia, CardActions, CardActionArea, Divider, Grid, Paper, Typography } from "@mui/material/";
import IconButton from "@mui/material/IconButton";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";

export default function MiniSearchBar() {
	const [bien, setBien] = useState(null);
	const [budget, setBudget] = useState(null);
	const [loc, setLoc] = useState(null);
	const [btnSearch, setBtnSearch] = useState(true);

	const setCriter = (idx, val) => {
		if (idx == 1) {
			setLoc(val);
		}
		if (idx == 2) {
			setBien(val);
		}
		if (idx == 3) {
			setBudget(val);
		}
	};

	useEffect(() => {
		//console.log(bien, budget, loc);
		if (bien !== null && budget !== null && loc !== null) {
			setBtnSearch(false);
		}
	}, [bien, budget, loc]);

	return (
		<Paper
			elevation={3}
			style={{
				maxWidth: "400px",
				borderRadius: 32,
				paddingLeft: "30px",
				margin: "0 auto",
				boxShadow: "0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(255 52 38 / 100%)",
			}}
		>
			<Box display="flex" justifyContent="space-between" p={1} m={1} css={({ width: "100%" }, { padding: "0px" })} alignItems="center">
				<Box p={1}></Box>

				<Box p={1}>
					<IconButton color="secondary" aria-label="add an alarm" href="/trouver-mon-appartement" disabled={btnSearch}>
						<GpsFixedIcon />
					</IconButton>
				</Box>
			</Box>
		</Paper>
	);
}
